import StoredLayout from '../../layouts/StoredLayout'
import Analytics from './Analytics'
export default StoredLayout(Analytics)
